import {
  Box
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { getEndpoint } from "../constants/api";
import { useNavigate } from "react-router-dom";
import CatchAll from "./CatchAll"; // import your new component

export default function StreamPage() {
  const [valid, setValid] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const MILLISECOND = 300000; // 5 minutes
  const navigate = useNavigate();

  // ------------------------------------------------
  // Check Device to see if user is still valid
  // ------------------------------------------------
  const checkDevice = async () => {
    const pack = sessionStorage.getItem("pack");
    if (!pack) {
      setIsLoaded(true);
      return navigate("/live");
    }
    let { ip, password } = JSON.parse(pack);
    const endpoint = getEndpoint(`checkdevice/${ip}/${password}`);

    try {
      const res = await fetch(endpoint);
      const data = await res.json();
      if (data === "valid") {
        setValid(true);
      } else {
        setValid(false);
      }
      setIsLoaded(true);
    } catch (error) {
      alert(error);
      setIsLoaded(true);
    }
  };

  // ------------------------------------------------
  // 1) Run on component mount
  // ------------------------------------------------
  useEffect(() => {
    checkDevice();
  }, []);

  // ------------------------------------------------
  // 2) Run every 5 minutes
  // ------------------------------------------------
  useEffect(() => {
    const interval = setInterval(() => {
      checkDevice();
    }, MILLISECOND);
    return () => clearInterval(interval);
  }, []);

  // ------------------------------------------------
  // If not valid, or just loaded -> redirect
  // ------------------------------------------------
  if (!valid && isLoaded) {
    alert("Please login");
    return navigate("/live");
  }

  // ------------------------------------------------
  // Otherwise, show CatchAll with the actual stream
  // ------------------------------------------------
  return (
    <Box backgroundColor="#4fbcd3" minHeight="100vh">
      <CatchAll />
    </Box>
  );
}
